<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M13.755 12.695h6.258l.436.735a.895.895 0 0 1 0 .992l-.278.415a.894.894 0 0 0-.055.896l.463.927a.896.896 0 0 1 0 .801l-.53 1.058a.897.897 0 0 0-.047.684l.154.463a.892.892 0 0 1-.216.916l-1.318 1.152h-6.276c-.342 0-.68.065-.997.192l-1.761.504M3.325 17.059l3.006-1.127c.373-.141.688-.402.896-.742l1.933-4.47c.203-.33.475-.612.798-.827l.673-.45"
  /><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M11.023 12.19 9.59 2.148a.504.504 0 0 1 .5-.578h7"
  /><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M14.005 12.695 13.22 4.9a.463.463 0 0 1 .464-.512h6.397a.464.464 0 0 1 .463.535l-1.166 7.773"
  /><path
    stroke="currentColor"
    stroke-width="1.75"
    d="M16.717 9.563a.348.348 0 0 1 0-.696M16.717 9.563a.348.348 0 1 0 0-.696"
  /></svg>
</template>
